<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>The Billionaire's Bride of Innocence</title>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="application/xhtml+xml; charset=utf-8" http-equiv="content-type"/>
<div class="frontMatterPage" id="fm01"><a id="pagei"><div class="chapterHead"><h2 class="chapterTitle1"><span class="bold"><span>“Why me?”</span></span></h2></div><div class="chapterBody"><p class="paraNoIndent1"><span>“Because you were perfect,” came his smoothly delivered reply.</span></p><p class="paraNoIndent1"><span>“Did you mind that I was a virgin?”</span></p><p class="paraNoIndent1"><span>“Mind? Why would I have minded?”</span></p><p class="paraNoIndent1"><span>She shrugged. “Because I was inexperienced. I dare say after a while you found me rather boring in bed.”</span></p><p class="paraNoIndent1"><span>“Megan, darling. I am being honest. I never thought you boring in bed. At the same time that doesn’t mean that I would not have one day moved our love life in a more…imaginative direction. I get the impression you wouldn’t object if I did during our second honeymoon….”</span></p><p class="paraNoIndent1"><span>“What do you mean by a more…imaginative direction?”</span></p><p class="paraNoIndent1"><span>“I don’t think this is the time or place to go into detail. If you trust me, however, as the more experienced partner, I will show you when we get to Dream Island.” His eyes caressed hers in the most seductive fashion.</span></p></div></a></div>
<a id="pagei">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// billionairesbrideofinnocencethe_fm01.vue?7e04e16c